import { useNavigate } from 'react-router-dom'

import { Button, Icon } from '@paysense-india-services/elevate-web'

import CardComponent from '@/components/CardComponent/index'

const DueRepaymentCard = ({ data }) => {
  const navigate = useNavigate()
  const handlePayClick = () => {
    if (data?.actions?.default?.url) {
      navigate(data.actions.default.url)
    }
  }

  const cardColor = data?.type === 'due_repayment' ? 'ew-bg-negative' : 'ew-bg-warning'

  return (
    <CardComponent className={`${cardColor} ew-border-none ew-color-inverse-primary`}>
      <div className='ew-d-flex ew-gap-10'>
        <Icon name='info' style={{ marginTop: '5px' }} />
        <div>
          <div className='ew-typography-large'>{data?.title}</div>
          <div className='ew-typography-small ew-fw-regular'>{data?.subtitle}</div>
        </div>
      </div>
      {data?.actions?.default?.text ? (
        <Button
          className='ew-bg-primary ew-color-brand ew-w-100 ew-mt-8'
          onClick={handlePayClick}
          size='medium'>
          {data?.actions?.default?.text}
        </Button>
      ) : null}
    </CardComponent>
  )
}

export default DueRepaymentCard
